export default "https://cdn-static.gokick.com/assets/7e5886a8604a8a782ca6a0de4eecb197b7d69c39/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";